import React from 'react';
import PropTypes from 'prop-types';
// import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// import Link from 'next/link';
import { spacing, fixedSpacing, colors } from '../../lib/theme';
import { ratingValue, secToDateDay, getIdFromUID, storageUrl } from '../../lib/utils';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HeartFilled } from '@ant-design/icons';
import { Avatar, Col, Rate, Row, Button, Tooltip } from 'antd';
import PodcastEpisode from '../Podcast/PodcastEpisode';
import Like from './Like';
import Report from './Report';
import AddReply from './AddReply';
import ReviewReplies from './ReviewReplies';
import ReviewOptions from './ReviewOptions';
import RatingModal from '../Podcast/RatingModal';
import ProfilePageRoute from '../Common/ProfilePageRoute';

class Review extends React.Component {
    // loadPage = () => {
    //   message.loading('Loading...', 0);
    //   // Dismiss manually and asynchronously
    //   // setTimeout(hide, 2500);
    // }
    constructor(props) {
        super(props);
        this.state = { addingReply: false, viewReplies: false };
    }

    pinReview = () => {
        const { review } = this.props;
        this.props.pinReview(review);
    }
    unpinReview = () => {
        const { review } = this.props;
        this.props.unpinReview(review);
    }

    addReply = () => {
        this.setState({ addingReply: true });
    }

    closeAddReply = () => {
        this.setState({ addingReply: false });
    }

    showReviewReplies = () => {
        this.setState({ viewReplies: true });
    }

    closeReviewReplies = () => {
        this.setState({ viewReplies: false });
    }

    render() {
        const { review, showEpisode, showLikeBar, type, showPrivacyType, userDetails, showYou, showReviewOptions, settingsState } = this.props;
        const { addingReply, viewReplies } = this.state;
        console.dir(review);
        console.dir(userDetails);
        const user = review.user;
        const collectionId = review.episode && review.episode.collectionId || -1;
        const currentUserUID = userDetails && userDetails.uid && getIdFromUID(userDetails.uid);

        const ownedPodcast = userDetails && userDetails.ownedPodcasts && userDetails.ownedPodcasts.includes(collectionId);
        console.dir(ownedPodcast);
        console.dir(type);
        const isReviewPublic = review.privacyType === 'public';

        return (
            <div className='review'>
                <div>
                    <Row>
                        {/* <Col style={{ marginTop: `${spacing('sm')}` }} span={1}>
                            <Avatar style={{ color: '#f56a00', backgroundColor: '#fde3cf' }}>{user && user.name && user.name[0] || 'U'}</Avatar>
                        </Col> */}
                        {(review.pinned == true) && <h5 style={{ marginBottom: `${spacing()}` }}><FontAwesomeIcon icon='thumbtack' />&nbsp;
                            Pinned by host</h5>}
                        <Col span={24}>
                            <Row style={{ marginBottom: `${spacing('xs')}`, marginLeft: '-4px' }}>
                                <Col xs={4} xl={1}>
                                    {(user && user.picUrl) ? <Avatar src={`${storageUrl}users/${user.picUrl}`} /> :
                                        <Avatar style={{ color: '#f56a00', backgroundColor: '#fde3cf' }}>{user && user.name && user.name[0] || 'U'}</Avatar>}
                                </Col>
                                <Col xl={22}>
                                    <h4 style={{ margin: '4px 0 4px 12px' }}><ProfilePageRoute profileUID={user.id}>{user && user.name} {showYou && (user.id == currentUserUID) && '(Me)'}</ProfilePageRoute></h4>
                                </Col>
                                <Col style={{ textAlign: 'right' }} span={1}>
                                    {type == 'episodeReviewList' && ownedPodcast && !review.pinned && isReviewPublic &&
                                        <div style={{ color: 'green' }}>
                                            <FontAwesomeIcon icon='thumbtack' />
                                            <a style={{ color: 'green' }} onClick={this.pinReview}>
                                                <Tooltip title='Pin this review'> Pin</Tooltip></a>
                                        </div>}
                                    {type == 'episodeReviewList' && ownedPodcast && review.pinned == true && <Tooltip title='Unpin this review'>
                                        <a style={{ color: 'red' }} onClick={this.unpinReview}>&nbsp; Unpin</a></Tooltip>}
                                </Col>
                            </Row>
                            <div style={{ display: 'flex' }}>
                                <Rate style={{ color: `${colors.third}`, fontSize: `${fixedSpacing('sm')}` }}
                                    character={<HeartFilled />} disabled allowHalf value={ratingValue(review.rating, 1, 'num')} />
                                <h5>&nbsp;{secToDateDay(review.postedDate.seconds)}
                                    {type == 'personalReview' && (review.postedDate.seconds != (review.lastModifiedDate && review.lastModifiedDate.seconds)
                                        && ` (edited)`)}</h5>
                                {(showPrivacyType || (user.id == currentUserUID)) && <h4 style={{ transform: 'translate(0, -2px)' }}>&nbsp;&nbsp;&nbsp;{isReviewPublic ?
                                    <Tooltip title='Public'>
                                        <div style={{ display: 'inline' }}>
                                            <FontAwesomeIcon icon='users' />
                                        </div>
                                    </Tooltip>
                                    :
                                    <Tooltip title='Private'>
                                        <div style={{ display: 'inline' }}>
                                            <FontAwesomeIcon icon='user' />
                                        </div>
                                    </Tooltip>
                                }
                                </h4>}
                                {(showReviewOptions && (user.id == currentUserUID)) && <div style={{ position: 'absolute', right: '0', display: 'flex' }}>
                                    <RatingModal parent='personalReview'
                                        podcastEpisode={review.episode} />&nbsp;&nbsp; &nbsp;&nbsp;
                                    <ReviewOptions review={review} />
                                </div>}
                            </div>
                            <p style={{ marginBottom: `${spacing('xs')}` }}>{review.comment || ''}</p>
                            {showEpisode && <div style={{ margin: `0 -1.25em 0 -1.25em` }}>
                                <PodcastEpisode showSeparator={false} parent={type} review={review} podcastEpisode={review.episode} />
                            </div>}
                            {isReviewPublic && <hr className='separator' />}
                            {showLikeBar && (isReviewPublic) && <Row style={{ display: 'flex', alignItems: 'center', padding: `0 0 ${spacing('xs')} ${spacing('xl')}` }}>
                                <Col xl={6}>
                                    <Like review={review} />
                                </Col>
                                <Col xl={2}>
                                    <Button onClick={this.addReply} type='outline'><FontAwesomeIcon icon='reply' />&nbsp; Reply</Button>
                                </Col>
                                <Col xl={8} offset={8} style={{ textAlign: 'right' }}>
                                    <div>
                                        <Report review={review} />
                                    </div>
                                </Col>
                            </Row>}
                            {addingReply && <AddReply review={review} closeAddReply={this.closeAddReply} />}
                            {review.hasReplies && (isReviewPublic) && <div style={{ padding: `0 0 ${spacing('xs')} ${spacing('xl')}` }}>
                                {!viewReplies && <a style={{ color: 'black' }} onClick={this.showReviewReplies}><p>View Replies <FontAwesomeIcon icon='chevron-down' /></p></a>}
                                {viewReplies && <a style={{ color: 'black' }} onClick={this.closeReviewReplies}><p>Hide Replies <FontAwesomeIcon icon='chevron-up' /></p></a>}
                            </div>}
                            {viewReplies && <ReviewReplies review={review} />}
                        </Col>
                    </Row>
                    {/* <div className='post-item' onClick={this.props.onClick}> */}
                </div>
                <style jsx>
                    {`
                        .review {
                            margin-bottom: ${spacing('md')};
                            background: ${settingsState.cardColor}; // white;
                            border-radius: ${spacing()};
                            padding: ${spacing('md')} ${spacing('lg')};
                        }
                        .separator {
                            height: 1px;
                            color: ${colors.primaryDim};
                            background-color: ${colors.primaryDim};
                            border: none;
                        }
                    `}
                </style>
            </div>
        );
    }
}

Review.defaultProps = {
    showEpisode: false,
    showLikeBar: true,
    showPrivacyType: false,
    showYou: false,
    showReviewOptions: false
}

Review.propTypes = {
    // userDetails: PropTypes.object,
    review: PropTypes.object.isRequired,
    showEpisode: PropTypes.bool,
    showLikeBar: PropTypes.bool,
    showPrivacyType: PropTypes.bool,
    showYou: PropTypes.bool,
    showReviewOptions: PropTypes.bool,
    type: PropTypes.string,
    userDetails: PropTypes.object,
    settingsState: PropTypes.object,
    pinReview: PropTypes.func,
    unpinReview: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        settingsState: state.settingsState,
    }
}

// export default podcast;
// const mapDispatchToProps = (dispatch) => {
//   return {
//   }
// };

export default connect(mapStateToProps, null)(Review)